import { RootState } from "store";

export const getModalRestrictions = (state: RootState) =>
  state.modalRestrictions;
